module.exports = __webpack_public_path__ + "static/Ravensoft-d49f1876422ae83cbecee545920c0c52.png";